import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import axios from "axios";
import { Check, Search, X } from "lucide-react";
import { toast } from "sonner";
import { API, fmtPhone, num } from "@/components/bulk/common";

export function ContactPicker({ initial, groups, title = "Kişi seç", onClose, onDone }) {
  const [sel, setSel] = useState(() => new Set(initial)), [q, setQ] = useState(""), [group, setGroup] = useState(""), [limit, setLimit] = useState(100), [data, setData] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => axios.get(`${API}/bulk/contacts`, { params: { q, group, status: "active", limit } }).then((r) => setData(r.data)).catch(() => toast.error("Kişiler yüklenemedi")), 250);
    return () => clearTimeout(t);
  }, [q, group, limit]);
  const toggle = (wa) => { const n = new Set(sel); n.has(wa) ? n.delete(wa) : n.add(wa); setSel(n); };
  const selectVisible = () => setSel(new Set([...sel, ...(data?.items || []).map((c) => c.wa)]));
  const selectAll = async () => {
    try { const r = await axios.get(`${API}/bulk/contacts/ids`, { params: { q, group, status: "active" } }); setSel(new Set([...sel, ...r.data.ids])); toast.success(`${num(r.data.ids.length)} kişi seçildi`); }
    catch { toast.error("Kişiler seçilemedi"); }
  };
  return createPortal(
    <div className="modal-backdrop picker-backdrop" onClick={(e) => { e.stopPropagation(); onClose(); }}>
      <div className="modal wide contact-picker" onClick={(e) => e.stopPropagation()} data-testid="contact-picker">
        <div className="modal-head"><div><span className="eyebrow">KİMLERE GİDECEK</span><h2>{title}</h2></div><button type="button" className="icon-btn" onClick={onClose} data-testid="contact-picker-close"><X /></button></div>
        <div className="contacts-toolbar">
          <label className="search-box"><Search size={15} /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Ad veya numara ara" data-testid="contact-picker-search" /></label>
          <select className="group-select" value={group} onChange={(e) => setGroup(e.target.value)} data-testid="contact-picker-group"><option value="">Tüm gruplar</option>{groups.map((g) => <option key={g.name} value={g.name}>{g.name}</option>)}</select>
        </div>
        <div className="picker-actions">
          <button type="button" className="text-btn" onClick={selectVisible} data-testid="contact-picker-select-visible">Görünenleri seç</button>
          <button type="button" className="text-btn" onClick={selectAll} data-testid="contact-picker-select-all">Hepsini seç{data ? ` (${num(data.total)})` : ""}</button>
          <button type="button" className="text-btn" onClick={() => setSel(new Set())} data-testid="contact-picker-clear">Seçimi temizle</button>
        </div>
        <div className="picker-list">
          {data?.items.map((c) => (
            <label key={c.wa} className={sel.has(c.wa) ? "picker-row on" : "picker-row"} data-testid={`contact-picker-row-${c.wa}`}>
              <input type="checkbox" checked={sel.has(c.wa)} onChange={() => toggle(c.wa)} data-testid={`contact-picker-check-${c.wa}`} />
              <b>{c.name || "İsimsiz"}</b><span>{fmtPhone(c.phone)}</span><span className="group-tags">{c.groups.map((g) => <i key={g}>{g}</i>)}</span>
            </label>
          ))}
          {data && data.items.length === 0 && <p className="empty">Eşleşen kişi yok.</p>}
          {data && data.items.length < data.total && limit < 1000 && <button type="button" className="outline-btn full" onClick={() => setLimit(limit + 100)} data-testid="contact-picker-more">Daha fazla göster</button>}
        </div>
        <div className="modal-actions"><span className="picker-count" data-testid="contact-picker-count"><b>{num(sel.size)}</b> kişi seçildi</span>
          <button type="button" className="primary-btn" onClick={() => onDone([...sel])} data-testid="contact-picker-done"><Check size={15} />Tamam</button></div>
      </div>
    </div>,
    document.body
  );
}
